/**
 * DemoStorageProvider - storage provider for demo launcher. Resolves @project/
 * paths relative to demo folders without requiring a project file.
 */

import { ENGINE_PATH_PREFIX, PROJECT_PATH_PREFIX } from '../const.js';

import { DefaultStorageProvider } from './defaultStorageProvider.js';
import { AssetPath, AssetPathEncodeState } from './storageProvider.js';


/**
 * Storage provider for demo launcher that resolves @project/ paths
 * relative to a demo-specific folder without requiring a project file.
 */
export class DemoStorageProvider extends DefaultStorageProvider {
  private readonly demoFolder: string;

  /**
   * @param demoFolder - The folder path for this demo's assets (e.g., 'demos/examples/my-demo')
   */
  constructor(demoFolder?: string) {
    super();
    this.demoFolder = demoFolder ?? '';
  }

  public override async resolvePath(path: AssetPath): Promise<AssetPath> {
    if (path.isResolved()) {
      return path;
    }

    if (path.initialPath.startsWith(PROJECT_PATH_PREFIX)) {
      // Strip @project/ prefix and resolve relative to demo folder
      const relativePath = AssetPath.stripPrefix(path.initialPath, PROJECT_PATH_PREFIX);
      const fullPath = this.demoFolder
        ? `/${this.demoFolder}/${relativePath}`
        : `/${relativePath}`;
      path.resolvePath(fullPath, AssetPathEncodeState.Unknown);
      return path;
    }

    if (path.initialPath.startsWith(ENGINE_PATH_PREFIX)) {
      const enginePath = AssetPath.stripPrefix(path.initialPath, ENGINE_PATH_PREFIX);
      path.resolvePath(enginePath, AssetPathEncodeState.Unknown);
    } else {
      console.log(`[DemoStorageProvider] Resolving regular path: ${path.initialPath}`);
      path.resolvePath(path.initialPath, AssetPathEncodeState.Unknown);
    }

    return path;
  }
}

